<template>
    <div id="sms-stats">
        <div class="row topactionform smallmargin">
            <div class="col-xs-3">
                <div class="smalltitle">SMS Statistics</div>
            </div>
            <div class="col-xs-9">
                <form class="onelineform flowsearch sms-filter" @submit.prevent="submitSearch">
                    <button type="submit" class="submit btn light" style="float: right; width: 8%"
                            title="Search"><i class="fa fa-search"></i>
                    </button>
                    <button type="button" class="btn light" style="float: right; width: 12%"
                            :disabled="isExporting" title="Export to Excel" @click.prevent="exportExcel">
                        <i v-if="isExporting" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fa fa-file-excel"></i> Export
                    </button>
                    <span class="selectwrap" style="width: 14%; float: right">
                        <select v-model="formSearch.status">
                            <option value="">All status</option>
                            <option value="ringcentral">Like RingCentral</option>
                            <option value="delivered">Delivered</option>
                            <option value="failed">Failed</option>
                            <option value="sending-failed">Not sent</option>
                        </select>
                    </span>
                    <span class="selectwrap" style="width: 10%; float: right">
                        <select v-model="formSearch.kind">
                            <option value="">All</option>
                            <option value="send">Sent</option>
                            <option value="receive">Received</option>
                        </select>
                    </span>
                    <date-picker v-model="formSearch.toDate"
                                 placeholder="To" title="Filter by date"
                                 format="MM/DD/YYYY"
                                 :clearable="true"
                                 :append-to-body=true
                                 lang="en" style="float: right;">
                    </date-picker>
                    <date-picker v-model="formSearch.fromDate"
                                 placeholder="From" title="Filter by date"
                                 format="MM/DD/YYYY"
                                 :clearable="true"
                                 :append-to-body=true
                                 lang="en" style="float: right;">
                    </date-picker>
                    <span class="selectwrap sms-clinic" style="width: 22%; float: right">
                        <select v-model="formSearch.ownerId">
                            <option value="">All clinics</option>
                            <option value="unassigned">Unassigned</option>
                            <option v-for="clinic in clinics" :key="clinic._id" :value="clinic._id">{{ clinic.name }}</option>
                        </select>
                    </span>
                </form>
            </div>
        </div>

        <div class="pftnav sms-tabs">
            <ul class="nav nav-tabs">
                <li class="tab-item" :class="{'active': selectedTab === tab.value}" v-for="tab in listTab"
                    :key="tab.value" @click="selectedTab = tab.value">
                    <a href="javascript:void(0)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>

        <div v-show="selectedTab === 1">
        <ul class="itemlisttable flowlisttype messageflow">
            <li class="itemlisthead">
                <div class="item-name">Clinic</div>
                <div class="item-num">Sent</div>
                <div class="item-num">Received</div>
                <div class="item-num">Segments sent</div>
                <div class="item-num">Segments received</div>
                <div class="item-num" title="Failed at RingCentral (still charged)">Failed</div>
                <div class="item-num" title="Never reached RingCentral (not in its log, not charged)">Not sent</div>
                <div class="item-num" title="Sent without a staff sender (reminders)">Automated</div>
                <div class="item-num" title="Sent by a staff member">Manual</div>
                <div class="item-num" title="Segments RingCentral charges: sent + received, not counting messages that were never sent">Total segments</div>
            </li>
            <li v-if="isLoadingSummary" style="text-align: center; color: #d9df20; font-size: 16pt">
                <i class="fas fa-spinner fa-spin"></i>
            </li>
            <li v-if="!isLoadingSummary && byClinic.length === 0" style="text-align: center; font-size: 16pt">
                No records found
            </li>
            <li v-if="!isLoadingSummary" v-for="item in byClinic" :key="item.ownerId" style="cursor: pointer"
                @click.prevent="pickClinic(item)">
                <div class="item-name"><b>{{ item.name }}</b></div>
                <div class="item-num">{{ formatNumber(item.sent) }}</div>
                <div class="item-num">{{ formatNumber(item.received) }}</div>
                <div class="item-num">{{ formatNumber(item.segmentsSent) }}</div>
                <div class="item-num">{{ formatNumber(item.segmentsReceived) }}</div>
                <div class="item-num">{{ formatNumber(item.failed) }}</div>
                <div class="item-num">{{ formatNumber(item.notSent) }}</div>
                <div class="item-num">{{ formatNumber(item.auto) }}</div>
                <div class="item-num">{{ formatNumber(item.manual) }}</div>
                <div class="item-num"><b>{{ formatNumber(item.segmentsTotal) }}</b></div>
            </li>
            <li v-if="!isLoadingSummary && byClinic.length > 1">
                <div class="item-name"><b>Total</b></div>
                <div class="item-num"><b>{{ formatNumber(total.sent) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.received) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.segmentsSent) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.segmentsReceived) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.failed) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.notSent) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.auto) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.manual) }}</b></div>
                <div class="item-num"><b>{{ formatNumber(total.segmentsTotal) }}</b></div>
            </li>
        </ul>


            <div class="smalltitle sms-section">By status</div>
            <ul class="itemlisttable flowlisttype messageflow">
                <li class="itemlisthead">
                    <div class="item-status-kind">Direction</div>
                    <div class="item-status-name">Status</div>
                    <div class="item-status-count">Messages</div>
                </li>
                <li v-if="!isLoadingSummary && byStatus.length === 0" style="text-align: center; font-size: 16pt">
                    No records found
                </li>
                <li v-if="!isLoadingSummary" v-for="item in byStatus" :key="item.kind + item.status">
                    <div class="item-status-kind">{{ item.kind }}</div>
                    <div class="item-status-name" :style="item.status === 'DeliveryFailed' ? {color: '#c0392b'} : {}">{{ statusLabel(item.status) }}</div>
                    <div class="item-status-count">{{ formatNumber(item.count) }}</div>
                </li>
            </ul>
        </div>

        <div v-show="selectedTab === 2">
            <div class="sms-total" v-if="!isLoadingDetails">
                Total: <b>{{ formatNumber(paginate.total) }}</b> messages
            </div>
        <ul class="itemlisttable flowlisttype messageflow">
            <li class="itemlisthead">
                <div class="item-date">Date</div>
                <div class="item-clinic">Clinic</div>
                <div class="item-kind">Direction</div>
                <div class="item-phone">From</div>
                <div class="item-phone">To</div>
                <div class="item-seg">Segments</div>
                <div class="item-status">Status</div>
                <div class="item-partner">RingCentral ID</div>
                <div class="item-content">Content</div>
            </li>
            <li v-if="isLoadingDetails" style="text-align: center; color: #d9df20; font-size: 16pt">
                <i class="fas fa-spinner fa-spin"></i>
            </li>
            <li v-if="!isLoadingDetails && details.length === 0" style="text-align: center; font-size: 16pt">
                No records found
            </li>
            <li v-if="!isLoadingDetails" v-for="item in details" :key="item._id">
                <div class="item-date">
                    <span>{{ formatDate(item.createdAt) }}</span>
                    <span style="display: block">{{ formatClock(item.createdAt) }}</span>
                </div>
                <div class="item-clinic"><b>{{ item.clinic }}</b></div>
                <div class="item-kind">{{ item.kind === 'receive' ? 'Received' : 'Sent' }}</div>
                <div class="item-phone">{{ formatPhone(item.from) }}</div>
                <div class="item-phone">{{ formatPhone(item.to) }}</div>
                <div class="item-seg">{{ item.segments }}</div>
                <div class="item-status" :style="item.status === 'DeliveryFailed' ? {color: '#c0392b'} : {}">{{ statusLabel(item.status) }}</div>
                <div class="item-partner">{{ item.smsPartnerId }}</div>
                <div class="item-content" :title="item.body">{{ item.body }}</div>
            </li>
        </ul>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import axios from '../../client'
import Common from '../mixins/Common.vue'
import Pagination from '../../global/Pagination.vue'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'

// Same time zone as the RingCentral account (and as the server filter): every date here is Central time
const SMS_TIME_ZONE = 'America/Chicago'

const emptyTotal = () => ({ sent: 0, received: 0, segmentsSent: 0, segmentsReceived: 0, segmentsTotal: 0, failed: 0, notSent: 0, auto: 0, manual: 0 })

export default {
  name: 'sms-stats',
  components: { Pagination, DatePicker },
  mixins: [Common],
  data () {
    return {
      selectedTab: 1,
      listTab: [
        { value: 1, name: 'Summary' },
        { value: 2, name: 'Messages' }
      ],
      formSearch: {
        ownerId: '',
        kind: '',
        status: 'ringcentral',
        fromDate: moment().subtract(1, 'months'),
        toDate: moment()
      },
      clinics: [],
      total: emptyTotal(),
      byClinic: [],
      byStatus: [],
      details: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoadingSummary: false,
      isLoadingDetails: false,
      isExporting: false
    }
  },
  mounted () {
    this.loadClinics()
    this.submitSearch()
  },
  methods: {
    statusLabel (status) {
      return { DeliveryFailed: 'Failed', SendingFailed: 'Not sent' }[status] || status
    },
    formatNumber (number) {
      return Number(number || 0).toLocaleString('en-US')
    },
    formatDate (date) {
      return date ? new Intl.DateTimeFormat('en-US', {
        timeZone: SMS_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date(date)) : ''
    },
    formatClock (date) {
      return date ? new Intl.DateTimeFormat('en-US', {
        timeZone: SMS_TIME_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
      }).format(new Date(date)) : ''
    },
    buildParams () {
      return {
        ownerId: this.formSearch.ownerId,
        kind: this.formSearch.kind,
        status: this.formSearch.status,
        fromDate: this.formSearch.fromDate ? moment(this.formSearch.fromDate).format('YYYY-MM-DD') : '',
        toDate: this.formSearch.toDate ? moment(this.formSearch.toDate).format('YYYY-MM-DD') : ''
      }
    },
    pickClinic (item) {
      this.formSearch.ownerId = item.ownerId
      this.submitSearch()
    },
    submitSearch () {
      this.paginate.page = 1
      this.loadSummary()
      this.loadDetails()
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadDetails()
    },
    async loadClinics () {
      try {
        const response = await axios.get('/sms-stats/clinics')
        if (response.data.s === 200) {
          this.clinics = response.data.data.clinics
        }
      } catch (e) {
        this.alertError('Server error when load clinics. Press F5 to refresh browser')
      }
    },
    async loadSummary () {
      this.isLoadingSummary = true
      try {
        const response = await axios.get('/sms-stats/summary', { params: this.buildParams() })
        if (response.data.s === 200) {
          this.total = response.data.data.total
          this.byClinic = response.data.data.clinics
          this.byStatus = response.data.data.statuses
        } else {
          this.total = emptyTotal()
          this.byClinic = []
          this.byStatus = []
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError('Server error when load data. Press F5 to refresh browser')
      }
      this.isLoadingSummary = false
    },
    async loadDetails () {
      this.isLoadingDetails = true
      try {
        const params = Object.assign(this.buildParams(), { page: this.paginate.page, perPage: this.paginate.perPage })
        const response = await axios.get('/sms-stats/details', { params: params })
        if (response.data.s === 200) {
          this.details = response.data.data.data
          this.paginate.page = Number(response.data.data.currentPage)
          this.paginate.total = Number(response.data.data.total)
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.details = []
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError('Server error when load data. Press F5 to refresh browser')
      }
      this.isLoadingDetails = false
    },
    async exportExcel () {
      if (this.isExporting) {
        return
      }
      this.isExporting = true
      try {
        const response = await axios.get('/sms-stats/export', { params: this.buildParams(), responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = `sms-stats-${moment().format('YYYYMMDD-HHmmss')}.xlsx`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        let msg = 'Server error when export. Try again later'
        try {
          if (e.response && e.response.data instanceof Blob) {
            msg = JSON.parse(await e.response.data.text()).msg || msg
          }
        } catch (ignore) {
          // keep default message
        }
        this.alertError(msg)
      }
      this.isExporting = false
    }
  }
}
</script>

<style>
    /* filter bar fills the whole column: the clinic select takes the remaining width */
    #sms-stats .sms-filter {
        display: flex;
        flex-direction: row-reverse;
        width: 100%;
    }

    #sms-stats .sms-filter > * {
        float: none !important;
        flex: 0 0 auto;
    }

    #sms-stats .sms-filter > .sms-clinic {
        flex: 1 1 auto;
        width: auto !important;
        min-width: 0;
    }

    /* every column of every table is left aligned (header and cells), same gap on both sides */
    #sms-stats .itemlisttable > li > div {
        text-align: left;
        padding-left: 10px;
        padding-right: 10px;
        box-sizing: border-box;
    }

    /* numbers are right aligned */
    #sms-stats .itemlisttable > li > div.item-num,
    #sms-stats .itemlisttable > li > div.item-seg,
    #sms-stats .itemlisttable > li > div.item-status-count {
        text-align: right;
    }

    #sms-stats .itemlisttable > li > div.item-content {
        white-space: normal;
        overflow: visible;
    }

    #sms-stats .mx-datepicker {
        width: 13%;
    }

    #sms-stats .mx-input {
        height: 40px;
    }
</style>
<style scoped="">
    .sms-tabs {
        display: inline-block;
        margin: 15px 0 10px;
    }

    .sms-total {
        margin: 0 0 8px;
        font-size: 11pt;
    }

    /* same look as the tabs of the detail modals (white active tab on grey bar) */
    .sms-tabs .nav-tabs {
        display: flex;
        border: 0;
        font-family: Montserrat, Arial;
    }

    .sms-tabs .nav-tabs > li {
        width: auto;
        flex: 0 0 180px;
        margin-bottom: 0;
    }

    .sms-tabs .nav-tabs > li > a:hover,
    .sms-tabs .nav-tabs > li.active > a:hover {
        background: #d9df20;
        color: #fff;
    }

    .item-name {
        width: 19% !important;
        float: left;
        min-height: 1px;
    }

    .item-num {
        width: 9% !important;
        float: left;
        min-height: 1px;
    }

    .item-date {
        width: 9% !important;
        float: left;
        min-height: 1px;
    }

    .item-clinic {
        width: 12% !important;
        float: left;
        min-height: 1px;
    }

    .item-kind {
        width: 8% !important;
        float: left;
        min-height: 1px;
    }

    .item-phone {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }

    .item-seg {
        width: 6% !important;
        float: left;
        min-height: 1px;
    }

    .item-status {
        width: 9% !important;
        float: left;
        min-height: 1px;
    }

    .item-content {
        width: 26% !important;
        float: left;
        min-height: 1px;
        padding-right: 10px;
        word-break: break-word;
        white-space: pre-wrap;
    }

    .item-status-kind,
    .item-status-name,
    .item-status-count {
        width: 33% !important;
        float: left;
        min-height: 1px;
    }

    .sms-section {
        margin: 15px 0 5px;
    }

    .item-partner {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }
</style>
